export const indexName = process.env.GATSBY_ALGOLIA_INDEX_NAME
export const currency = "£"
export const defaultArea = process.env.GATSBY_DEFAULT_AREA
  ? process.env.GATSBY_DEFAULT_AREA
  : "London"
export const defaultAreaSlug = defaultArea.toLowerCase().replace(/ /g, "-")

export const defaultAreaNewhomes = process.env.GATSBY_DEFAULT_AREA_NEWHOMES
  ? process.env.GATSBY_DEFAULT_AREA_NEWHOMES
  : defaultArea
export const defaultAreaNewhomesSlug = defaultAreaNewhomes
  .toLowerCase()
  .replace(/ /g, "-")

export const siteName = process.env.GATSBY_SITE_NAME

export const defaultReviewKey =
  "VU2vdw7EjwD5FU9iwEZRsllKhk0fswOUxg2bTx9hFFDUOhJMtVsfxflxvwON"
export const defaultReviewId = "estas-widget-1cc92f"
export const apiAddressyKey = "GX75-EJ94-WK94-WB77"

export const PropertySearchURL = {
  residential: {
    sales: "/property/for-sale/",
    lettings: "/property/to-rent/",
    newdevelopments: "/new-developments/for-sale/",
  },
  commercial: {
    sales: "/commercial-property/for-sale/",
    lettings: "/commercial-property/to-rent/",
  },
}

export const PropertyDetailsURL = {
  residential: {
    sales: "/property-for-sale/",
    lettings: "/property-to-rent/",
    newhomes: "/new-homes-for-sale/",
    newdevelopments: "/new-developments-for-sale/",
  },
  commercial: {
    sales: "/commercial-property-for-sale/",
    lettings: "/commercial-property-to-rent/",
  },
  auctions: {
    sales: "/auctions-for-sale/",
  },
}

export const SearchType = {
  sales: "For Sale",
  lettings: "To Rent",
}

export const PropertyStatus = [
  "Let",
  "Under Offer",
  "Sold",
  "Sale Agreed",
  "Let Agreed",
]

export const TeamDepartments = [
  { label: "All Department", value: "" },
  { label: "Sales", value: "sales" },
  { label: "Lettings", value: "lettings" },
  { label: "Commercial", value: "commercial" },
  { label: "Directors", value: "directors" },
  { label: "Marketing", value: "marketing" },
  { label: "Negotiators", value: "negotiators" },
]

export const MilesDistance = [
  { label: "Radius", value: "" },
  { label: "+1 mile", value: "1 mile" },
  { label: "+3 miles", value: "3 miles" },
  { label: "+4 miles", value: "4 miles" },
  { label: "+6 miles", value: "6 miles" },
  { label: "+8 miles", value: "8 miles" },
  { label: "+10 miles", value: "10 miles" },
  { label: "+15 miles", value: "15 miles" },
  { label: "+30 miles", value: "30 miles" },
  { label: "+60 miles", value: "60 miles" },
  { label: "+90 miles", value: "90 miles" },
  { label: "+120 miles", value: "120 miles" },
]
